import axios from 'axios'

const ACCESS_KEY  = '5mi_admin_access'
const REFRESH_KEY = '5mi_admin_refresh'

export const tokenStorage = {
  getAccess:   ()                    => localStorage.getItem(ACCESS_KEY),
  getRefresh:  ()                    => localStorage.getItem(REFRESH_KEY),
  setTokens:   ({ access, refresh }) => {
    localStorage.setItem(ACCESS_KEY, access)
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh)
  },
  clearTokens: () => {
    localStorage.removeItem(ACCESS_KEY)
    localStorage.removeItem(REFRESH_KEY)
  },
}

const BASE_URL = ''

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15_000,
})

api.interceptors.request.use((config) => {
  const token = tokenStorage.getAccess()
  if (token) config.headers.Authorization = `Bearer ${token}`
  // FormData: delete Content-Type to let browser/axios set multipart/form-data automatically
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  } else if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})

let _refreshing = false
let _queue      = []

function drainQueue(error, token = null) {
  _queue.forEach(({ resolve, reject }) => error ? reject(error) : resolve(token))
  _queue = []
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config
    if (
      error.response?.status !== 401 ||
      original._retry ||
      original.url?.includes('/api/auth/token/refresh/')
    ) return Promise.reject(error)

    if (_refreshing) {
      return new Promise((resolve, reject) => _queue.push({ resolve, reject }))
        .then((token) => { original.headers.Authorization = `Bearer ${token}`; return api(original) })
    }

    original._retry = true
    _refreshing     = true
    const refreshToken = tokenStorage.getRefresh()

    if (!refreshToken) {
      tokenStorage.clearTokens(); drainQueue(error); _refreshing = false
      window.dispatchEvent(new CustomEvent('auth:logout'))
      return Promise.reject(error)
    }

    try {
      const { data } = await axios.post(`${BASE_URL}/api/auth/token/refresh/`, { refresh: refreshToken })
      tokenStorage.setTokens({ access: data.access, refresh: data.refresh })
      api.defaults.headers.common.Authorization = `Bearer ${data.access}`
      drainQueue(null, data.access)
      original.headers.Authorization = `Bearer ${data.access}`
      return api(original)
    } catch (err) {
      tokenStorage.clearTokens(); drainQueue(err)
      window.dispatchEvent(new CustomEvent('auth:logout'))
      return Promise.reject(err)
    } finally {
      _refreshing = false
    }
  },
)

export default api

